import { render } from "./QuestionMark.vue?vue&type=template&id=7dbb845c"
import script from "./QuestionMark.vue?vue&type=script&lang=js"
export * from "./QuestionMark.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__